import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CarteleraResponse } from '../interfaces/cartelera-response';
import { Movie } from '../interfaces/cartelera-response';

import { tap, map, catchError } from 'rxjs/operators';
import { MovieDetailsResponse } from '../interfaces/movie-response';
import { CastingResponse, Cast } from '../interfaces/casting-response';
import { PersonResponse } from '../interfaces/person-response';
import { SimilarMovie, SimilarMovieResponse } from '../interfaces/similar-movie-response';
import { MoviesByActorResponse, KnownFor } from '../interfaces/moviesbyactor-response';


@Injectable({
  providedIn: 'root'
})
export class PeliculasService {

  private baseUrl = 'https://api.themoviedb.org/3';
  private carteleraPage = 1;
  public cargando: boolean = false;
  public moviesByActor: MoviesByActorResponse[] = [];

  constructor( private http: HttpClient) { }

  get params(): {} {
    return {
    api_key: '70f73c55148d2e40d7ce9bdef25ffbfb',
    language: 'es-ES',
    page: this.carteleraPage.toString()
    }
  }

  // tslint:disable-next-line:typedef
  getCartelera(): Observable<Movie[]> {
    if ( this.cargando ){
      return of([]);
    }

    this.cargando = true;

    return this.http.get<CarteleraResponse>(`${this.baseUrl}/movie/now_playing?`, {params: this.params})
    .pipe(
      map( (resp) => resp.results),
      tap (() => {
      this.carteleraPage += 1;
      this.cargando = false;
    }));
  }

  buscarPelicula( text: string ): Observable<Movie[]>{
    const params = { ...this.params, page: '1', query: text };
    return this.http.get<CarteleraResponse>(`${this.baseUrl}/search/movie`, {params})
    .pipe(
      map( resp => resp.results)
    );
  }

  resetCarteleraPage(): void{
    this.carteleraPage = 1;
  }

  getMovieDetail( id: number): Observable<any> {
    return this.http.get<MovieDetailsResponse>(`${this.baseUrl}/movie/${ id }`, {params : this.params})
    .pipe(
      catchError( err => of(null))
    );
  }

  getCasting( id: number): Observable<Cast[]>{
    return this.http.get<CastingResponse>(`${this.baseUrl}/movie/${id}/credits`, { params : this.params})
      .pipe( map ( resp => resp.cast ),
      catchError( err => of([]))
    );
  }

  getPerson( id: number ): Observable<PersonResponse>{
    return this.http.get<PersonResponse>(`${this.baseUrl}/person/${id}`, { params : this.params});
  }

  getSimilarMovies( id: number): Observable<SimilarMovie[]>{
    return this.http.get<SimilarMovieResponse>(`${this.baseUrl}/movie/${id}/similar`, { params : this.params})
    .pipe(map (resp => resp.results),
    catchError( err => of([])));
  }

  getMoviesByActor( name: string ): Observable<MoviesByActorResponse[]> {
    const params = { ...this.params, page: '1', query: name };
    const results = this.http.get(`${this.baseUrl}/search/person?`, { params})
    .pipe(map ((resp: any) => resp.results),
    catchError( err => of([]))
    );
    // console.log(results);
    return results;
  }

  // https://api.themoviedb.org/3/search/person?api_key=70f73c55148d2e40d7ce9bdef25ffbfb
  // &language=en-US&query=jessica%20alba
}
